import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';

const EnergyTable = ({ machine, name, Data, filters, Draw, totals }) => {
  const containerRef = useRef(null);
  const canvasRef = useRef(null);

  const getDimensions = () => {
    if (!containerRef.current || !Data || Data.length === 0) return null;

    const container = containerRef.current;
    const padding = {
      leftPadding: 10,
      topPadding: 10,
      bottomPadding: 10,
      rightPadding: 10,
    };

    const width = Draw ? 1200 : container.clientWidth - padding.leftPadding - padding.rightPadding;
    const height = Draw ? 500 : container.clientHeight - padding.topPadding - padding.bottomPadding;

    if (width <= 0 || height <= 0 || Data.error) return null;

    const maxTotalWatt = Math.max(...Data.map(o => o?.totalWatt || 0));
    const maxOpladenWatt = Math.max(...Data.map(o => o?.opladenWatt || 0));
    const maxWatt = Math.max(maxOpladenWatt, maxTotalWatt);
    const maxHeight = Math.max(maxWatt / 1000, 1);

    return {
      padding,
      width,
      height,
      lineHeight: Math.min(height / (Data.length + 1), 30),
      lineWidth: (width - 20) / (Object.values(filters).filter((e) => e.value).length + 2),
      maxHeight,
      wattHeight: height / maxHeight
    };
  }

  const drawLines = (context, dimensions) => {
    if (!context || !Data) return null;

    context.beginPath();
    context.fillStyle = "#f72";

    context.rect(dimensions.padding.leftPadding, dimensions.padding.topPadding, dimensions.width - dimensions.padding.rightPadding * 2, dimensions.lineHeight);
    context.fill();

    context.beginPath();
    context.strokeStyle = "#000";
    context.fillStyle = "#fff";
    context.font = "bold 18px sans-serif";
    context.lineWidth = 1.5;

    const titles = [
      "Datum",
      "Urenstand",
    ]

    Object.entries(Data[0]).filter((e) => filters[e[0]]?.value).map((data) => {
      titles.push(data[1].name)
    })

    for(let i = 0; i < 6 + 1; i++) {
      context.fillText(titles[i], dimensions.lineWidth * i + dimensions.lineWidth / 2 - context.measureText(titles[i]).width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight + 3);
    }

    for(let i = 0; i < 6 + 1; i++) {
      context.moveTo(dimensions.padding.leftPadding + dimensions.lineWidth * i, dimensions.padding.topPadding);
      context.lineTo(dimensions.padding.leftPadding + dimensions.lineWidth * i, dimensions.lineHeight * (Data.length + 2) + dimensions.padding.topPadding);
    }

    for(let i = 0; i < Data.length + 3; i++) {
      context.moveTo(dimensions.padding.leftPadding, dimensions.padding.topPadding + dimensions.lineHeight * i);
      context.lineTo(dimensions.width - dimensions.padding.rightPadding, dimensions.padding.topPadding + dimensions.lineHeight * i);
    }

    context.stroke()
  }

  const drawData = (context, dimensions) => {
    if (!context || !dimensions || !Data) return null;

    Data.map((data, i) => {
      context.beginPath();
      context.fillStyle = "#000";
      context.font = "20px sans-serif";
      context.fillText(data.date,dimensions.lineWidth / 2 - context.measureText(data.date).width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight * (i + 2) + 5);
      console.log(Object.values(data))
      let index = 0
      Object.values(data).map((item) => {
        if (!item.value) return
        index++
        if (item.tableIndex === 10) item.tableIndex = index - 1;
        context.fillText((item.value / 1000).toFixed(1) ,dimensions.lineWidth * (item.tableIndex + 2) + dimensions.lineWidth / 2 - context.measureText((item.value / 1000).toFixed(1)).width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight * (i + 2) + 5);
      })
      context.fillText((data.urenstand) ,dimensions.lineWidth + dimensions.lineWidth / 2 - context.measureText((data.urenstand)).width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight * (i + 2) + 5);
    })

    context.fillText("Totaal",dimensions.lineWidth / 2 - context.measureText("Totaal").width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight * (Data.length + 2) + 5);

    totals = Object.values(totals).filter((e) => e > 0);

    Object.values(totals).forEach((d, i) => {
      context.fillText((d / 1000).toFixed(1) ,dimensions.lineWidth * (i + 2) + dimensions.lineWidth / 2 - context.measureText((d / 1000).toFixed(1)).width / 2 + dimensions.padding.leftPadding, dimensions.lineHeight * (Data.length + 2) + 5);
    })
  }

  const draw = () => {
    if (Data?.error) {
      error()
      return
    }
    if (!canvasRef) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const dimensions = getDimensions();

    if (!dimensions) return;

    const container = containerRef.current;
    if (container) {
      canvas.width = dimensions.width + dimensions.padding.leftPadding + dimensions.padding.rightPadding;
      canvas.height = dimensions.height + dimensions.padding.topPadding + dimensions.padding.bottomPadding;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    drawLines(ctx, dimensions);

    drawData(ctx, dimensions);
  }

  const error = () => {
    if (!canvasRef && canvasRef.current) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const container = containerRef.current;
    if (container) {
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
    }

    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#000000";
    ctx.font = "120px Arial"
    const size = ctx.measureText(Data.error);
    ctx.fillText(Data.error, canvas.width / 2 - size.width / 2, canvas.height / 2)
  }

  const loading = () => {

    console.log("Loading...");

    if (!canvasRef && canvasRef.current) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const container = containerRef.current;
    if (container) {
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
    }

    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#000000";
    ctx.font = "80px Arial"
    const size = ctx.measureText("Laden...");
    ctx.fillText("Laden...", canvas.width / 2 - size.width / 2, canvas.height / 2)
  }

  useEffect(() => {
    if(Data) draw()
    else loading()
  }, [Data, filters, Draw])

  window.addEventListener("resize", draw);

  return (
    <div ref={containerRef} id={"container-" + name} className="w-full h-96">
      <canvas ref={canvasRef} id={"canvas-" + name}></canvas>
    </div>
  );
};

export default EnergyTable;
